module.exports = __webpack_public_path__ + "static/contigo1-7b32badbf7a13d3a17906e373efc4296.jpg";